import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.25 1.299a4.864 4.864 0 0 0-6.79.166c-1.947 1.97-1.946 5.051.001 7.013l6.066 6.112a.822.822 0 0 0 1.379.07l6.134-6.182c1.947-1.962 1.947-5.043-.002-7.016A4.88 4.88 0 0 0 11.556 0 4.87 4.87 0 0 0 8.25 1.299"
    }, null, -1)
  ])))
}
export default { render: render }